import { Link as ReactRouterLink } from "react-router-dom";

export default ReactRouterLink;
